import { gql } from "@apollo/client";

export const getKeyholdingSiteBillingBySiteIdQuery = gql`
query GetKeyholdingSiteBillingBySiteId($siteId: String!) {
  getKeyholdingSiteBillingBySiteId(siteId: $siteId) {
    response
    message
  }
}

`;